// package
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// componet
import Pill from "../../../common/Pill";
// styles
import styles from "./CashoutApproved.module.scss";

const CashoutApproved = () => {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="CashoutApproved"
      Lefticon={
        <img
          src={"../../../assets/images/svg/cashoutApproved_status_list.svg"}
        />
      }>
      <p className={classNames(styles.text, "p2")}>
        {t("global_status_transfer")}
      </p>
    </Pill>
  );
};

export default CashoutApproved;
